import styled from 'styled-components';

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin: 0 0 16px 0;
`;

const TableRow = styled.tr`
  border: 1px solid var(--greyWolf);
`;

const TableHeaderCell = styled.td`
  padding: 4px 16px;
  color: var(--greyWolf);
`;

const TableCell = styled.td`
  padding: 16px;
`;

export {
  TableRow as TableRowStyled,
  TableCell as TableCellStyled,
  TableHeaderCell as TableHeaderCellStyled,
};
export default Table;
